module.exports = __webpack_public_path__ + "img/track.2696ffec.svg";